import axios from "axios";
import React, { useEffect, useState } from "react";
import Modal from "../../components/modal";
import ButtonSelector from "../../components/ButtonSelector";
import './index.css'
import FormPost from "../../components/FormPost";
import { useDispatch, useSelector } from "react-redux";
import { clearVisoriasState, setAllVisoriasPost, setHideModalPost, setNewVisoriaPost, setShowModalPost } from "./redux/actions";
import { IoMdClose } from "react-icons/io";
import ListVisoriasPost from "./components/ListVisoriasPost";




const VisoriaScreen = ()=>{
    const dispatch = useDispatch();
    const showModal = useSelector(state => state?.visorias?.showModal)
    const newPost = useSelector(state => state?.visorias?.newPost)
    const allPost = useSelector(state => state?.visorias?.allPost)

    useEffect(()=>{
        const url = 'https://web-production-58ed.up.railway.app/api/get/allVisorias'
        axios.get(url).then(res =>{
            
            dispatch(setAllVisoriasPost(res.data?.visorias))
        } )

    },[newPost._id])

    useEffect(()=>{

        return ()=>{
            dispatch(clearVisoriasState())
        }
    },[])

        const handleUpdateStore = (data)=>{
                dispatch(setNewVisoriaPost(data.publicacion))
                dispatch(setHideModalPost())
        }

    const renderModal = ()=>(
        <>
        {showModal && (<Modal> 
            <FormPost text={'Ingresa todos los detalles de la visoria'} handleUpdateStore={handleUpdateStore} typePost={'visorias'}  />
            <div className="modal-screen-button-close" onClick={()=> dispatch(setHideModalPost())} >
                <IoMdClose style={{width:'40px', height:'40px'}} />

            </div>
        </Modal>)}
        </>
    )

    return(
        <div>
            {renderModal()}
            <div className="visoria-screen-selector-section">
            <ButtonSelector handleShowModal={()=> dispatch(setShowModalPost())} title={'Crea una publicación para promocionar una visoria'} />
            </div>
            <ListVisoriasPost />
        </div>


    )
}
export default VisoriaScreen